import { EventSchema } from '../../interfaces/EventInterfaces'
import { EVENT_NAME as EN } from '../../constants/EventName'
import { EVENT_PARAM_KEY as EPK } from '../../constants/EventParamKey'

// Common voucher parameters that can be reused across voucher events
const getCommonVoucherParams = () => ({
  // common properties
  SESSION_ID_GA: EPK.SESSION_ID_GA,
  GCLID: EPK.GCLID,
  FBCLID: EPK.FBCLID,
  REFERRER: EPK.REFERRER,
  REFERRING_DOMAIN: EPK.REFERRING_DOMAIN,
  SCREEN_NAME: EPK.SCREEN_NAME,
  SCREEN_SECTION: EPK.SCREEN_SECTION,
  PREVIOUS_SCREEN_NAME: EPK.PREVIOUS_SCREEN_NAME,
  PREVIOUS_SCREEN_SECTION: EPK.PREVIOUS_SCREEN_SECTION,
  ENVIRONMENT: EPK.ENVIRONMENT,
  BUSINESS_VERTICAL: EPK.BUSINESS_VERTICAL,
  EVENT_CATEGORY: EPK.EVENT_CATEGORY,
  // voucher specific properties
  OFFER_ID: EPK.OFFER_ID,
  OFFER_TYPE: EPK.OFFER_TYPE,
  OFFER_SAP_REFERENCE: EPK.OFFER_SAP_REFERENCE,
  VOUCHER_NAME: EPK.VOUCHER_NAME,
  VOUCHER_CODE: EPK.VOUCHER_CODE,
  VOUCHER_POSITION: EPK.VOUCHER_POSITION,
  STORE_ID_SAP: EPK.STORE_ID_SAP,
  STORE_ID_DBP: EPK.STORE_ID_DBP,
  STORE: EPK.STORE,
})

export const VoucherViewEventSchema = (): EventSchema => {
  return {
    eventName: EN.VOUCHER_VIEW,
    params: getCommonVoucherParams(),
  }
}

export { getCommonVoucherParams }